module.exports = __webpack_public_path__ + "static/img/win_prize.5303a94.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/1215/win_prize.png
// module id = 470
// module chunks = 1